import * as Sentry from '@sentry/react';
import { useEffect } from 'react';

import User from 'types/models/user';

export const useSetSentryUser = (myUser: User | null) => {
  useEffect(() => {
    if (myUser) {
      Sentry.setUser({
        id: myUser.id,
        email: myUser.email,
        username: myUser.username
      });
    }
  }, [myUser]);
};